import axios from "./axios"
import { handleResponse } from "./util"

export const advertiserAPI = {
  /**
   * GET request to fetch coordinates of ALL available merchants
   * @param {number} advertiserId - current advertiser ID
   * @returns {object}
   * {
   *    merchant_coordinates: [{merchant_id: 1, longitude: '-75.0', latitude: '43.0'}],
   *    merchant_regions: ['Florida', 'New York']
   * }
   */
  getGeoData(advertiserId: number) {
    return axios.get(`/merchants/geo_data?brand_id=${advertiserId}`).then(handleResponse)
  }
}